import { ApolloLink } from 'apollo-link'
import moment from 'moment'

const loggerLink = new ApolloLink((operation, forward) => {
  console.log(`Operation: ${operation.operationName} started`)
  operation.setContext({ start: new Date() })
  return forward(operation).map((response) => {
    // Called after server responds
    const timeDiffInSec = moment().diff(
      operation.getContext().start,
      'milliseconds'
    )
    console.log(
      `Operation ${operation.operationName} took ${timeDiffInSec} millisecs to complete`
    )
    return response
  })
})

export default loggerLink
